var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1Unplug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 36h13v4H60a13.6 13.6 0 01-13.44 12H41V24h5.56A13.7 13.7 0 0160 36zm-44.24 0H3v4h12.73a13.72 13.72 0 0013.6 12H35V24h-5.67a13.82 13.82 0 00-13.57 12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Unplug.0dea487e.svg";
export { SvgA1Unplug as ReactComponent };